export default __webpack_public_path__ + "static/underline-universe-5eaa63c860ffb206df4910bb8256dd5d.svg";